import { Observable } from 'rxjs';
import { InvitationPayload, User, UserInvitation } from 'src/app/shared/types/users.types';
import { ListResponseWrapper } from '../../shared/http.types';
import { Injectable } from '@angular/core';

export interface IUserProvider {
  getUsers(accountId: string): Observable<ListResponseWrapper<User>>;
  changeUserState(userId: User['id'], accountId: string, state: 'activate'|'deactivate'): Observable<any>;
  changeRole(accountId: string, userId: string, role: User.GroupName): Observable<void>;
}

export interface IUserInvitationProvider {
  getInvitations(accountId: string): Observable<ListResponseWrapper<UserInvitation>>;
  cancelInvitation(invitationId: UserInvitation['id'], accountId: string): Observable<any>;
  resendInvitation(invitationId: UserInvitation['id'], accountId: string): Observable<any>;
  createInvitation(accountId: string, body: InvitationPayload): Observable<any>;
}

@Injectable({
  providedIn: 'root'
})
export abstract class UsersProviderService implements IUserProvider, IUserInvitationProvider {
  public readonly title: string;

  public abstract getUsers(accountId: string): Observable<ListResponseWrapper<User>>;
  public abstract changeUserState(userId: User['id'], accountId: string, state: 'activate'|'deactivate'): Observable<any>;
  public abstract changeRole(accountId: string, userId: string, role: User.GroupName): Observable<void>;

  public abstract getInvitations(accountId: string): Observable<ListResponseWrapper<UserInvitation>>;
  public abstract cancelInvitation(invitationId: UserInvitation['id'], accountId: string): Observable<any>;
  public abstract deleteInvitation(invitationId: UserInvitation['id'], accountId: string): Observable<any>;
  public abstract resendInvitation(invitationId: UserInvitation['id'], accountId: string): Observable<any>;
  public abstract createInvitation(accountId: string, body: InvitationPayload): Observable<any>;
}
